export default __webpack_public_path__ + "static/media/AskMeLogoAltOptimized.972c3204.jp2";